export default {
  "HitPaw Add Music to Audio Online": "HitPaw Çevrimiçi Sese Müzik Ekle",
  "Add BGM to Audio without any difficulties.": "Herhangi bir zorluk yaşamadan Sese BGM ekleyin.",
  "Add New": "Yeni Ekle",
  "Format": "Biçim",
  "Add tracks": "Parça ekle",

};
